import { baseURL, getIdToken } from "./client";

import axios from "axios";

/**
 * @param {{ pageSize?: number, pageNumber?: number, clientUid?: string }} params
 */
export const getAllServiceRequests = async ({
  pageSize = 25,
  pageNumber = 0,
  clientUid = undefined,
} = {}) =>
  axios({
    baseURL,
    url: `/service-requests/`,
    headers: {
      Authorization: `bearer ${await getIdToken()}`,
    },
    params: {
      pageSize,
      pageNumber,
      clientUid,
    },
  }).then(response => response.data);
